/**
 * The Help Center (docs.memberfy.net) prefix for a language: the variant,
 * lowercased (`/pt-br/`, `/de-ch/`). French has a single variant there, so
 * every French locale of the app opens `/fr-fr/`.
 */
export const helpCenterLocale = (language: string | null | undefined): string => {
  const code = (language || 'pt-BR').toLowerCase()
  return code.startsWith('fr') ? 'fr-fr' : code
}

/** A Help Center article in the reader's language: `path` is what follows the language prefix. */
export const helpCenterUrl = (language: string | null | undefined, path: string): string =>
  `https://docs.memberfy.net/${helpCenterLocale(language)}/${path.replace(/^\//, '')}`
